/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Italicize_Selected_EventsInputs */



/**
* | output |
* | --- |
* | "Italicize selected events" |
*
* @param {Italicize_Selected_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const italicize_selected_events = /** @type {((inputs?: Italicize_Selected_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Italicize_Selected_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mettre en italique les événements sélectionnés")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählte Ereignisse kursiv darstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Metti in corsivo gli eventi selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выделить курсивом выбранные события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Poner en cursiva los eventos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将选定事件用斜体显示")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントを斜体にする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चुनिंदा घटनाओं को इटैलिक में लिखें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Destaque os eventos selecionados em itálico")
	return /** @type {LocalizedString} */ ("Italicize selected events")
});